import { render } from "./McpSettings.vue?vue&type=template&id=6a53be88&scoped=true"
import script from "./McpSettings.vue?vue&type=script&lang=js"
export * from "./McpSettings.vue?vue&type=script&lang=js"

import "./McpSettings.vue?vue&type=style&index=0&id=6a53be88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a53be88"]])

export default __exports__